export default {
  signIn: 'Zaloguj się',
  signOut: 'Wyloguj się',
  points: 'punkty',
  hyattSignInButton: 'Zaloguj się do World of Hyatt',
};
